// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__f6xby","button-login":"styles_button-login__4z1ye","button-link":"styles_button-link__YZJcw"};